"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const FlatRoof_1 = __importDefault(require("../icon/svgs/FlatRoof"));
const OtherTraining_1 = __importDefault(require("../icon/svgs/OtherTraining"));
const PitchedRoof_1 = __importDefault(require("../icon/svgs/PitchedRoof"));
const styles_1 = require("./styles");
const getIcon = (category) => {
    switch (category) {
        case "pitched":
            return PitchedRoof_1.default;
        case "flat":
            return FlatRoof_1.default;
        case "other":
            return OtherTraining_1.default;
    }
};
const Category = ({ label, type, className }) => {
    return ((0, jsx_runtime_1.jsxs)(styles_1.TrainingAttribute, { "data-testid": "training-category", variant: "h6", className: className, children: [(0, jsx_runtime_1.jsx)(styles_1.StyledIcon, { source: getIcon(type) }), label] }));
};
exports.default = Category;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2F0ZWdvcnkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdHJhaW5pbmctY2FyZC9DYXRlZ29yeS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEscUVBQTZDO0FBQzdDLCtFQUF1RDtBQUN2RCwyRUFBbUQ7QUFDbkQscUNBQXlEO0FBU3pELE1BQU0sT0FBTyxHQUFHLENBQUMsUUFBc0IsRUFBcUIsRUFBRTtJQUM1RCxRQUFRLFFBQVEsRUFBRSxDQUFDO1FBQ2pCLEtBQUssU0FBUztZQUNaLE9BQU8scUJBQVcsQ0FBQztRQUNyQixLQUFLLE1BQU07WUFDVCxPQUFPLGtCQUFRLENBQUM7UUFDbEIsS0FBSyxPQUFPO1lBQ1YsT0FBTyx1QkFBYSxDQUFDO0lBQ3pCLENBQUM7QUFDSCxDQUFDLENBQUM7QUFFRixNQUFNLFFBQVEsR0FBRyxDQUFDLEVBQUUsS0FBSyxFQUFFLElBQUksRUFBRSxTQUFTLEVBQWlCLEVBQUUsRUFBRTtJQUM3RCxPQUFPLENBQ0wsd0JBQUMsMEJBQWlCLG1CQUNKLG1CQUFtQixFQUMvQixPQUFPLEVBQUMsSUFBSSxFQUNaLFNBQVMsRUFBRSxTQUFTLGFBRXBCLHVCQUFDLG1CQUFVLElBQUMsTUFBTSxFQUFFLE9BQU8sQ0FBQyxJQUFJLENBQUMsR0FBSSxFQUNwQyxLQUFLLElBQ1ksQ0FDckIsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLGtCQUFlLFFBQVEsQ0FBQyJ9